import { useEffect } from "react";

import { selectFeatureOrganizationsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import { getSetupCatalogThunk } from "../thunks/getSetupCatalog.thunk";

export const useLoadSetupCatalog = (organizationId?: string) => {
  const organizationEnabled = useAppSelector(selectFeatureOrganizationsEnabled);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (organizationEnabled && organizationId) {
      dispatch(getSetupCatalogThunk({ organizationId }));
    }
  }, [dispatch, organizationId, organizationEnabled]);
};
